import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";

import { SyncScrollService } from "./sync-scroll.service";

@Directive({
  selector: "[appSyncScroll]",
  standalone: false, // NOSONAR - will be make this true in R2.
})
export class SyncScrollDirective implements OnInit, OnDestroy {
  @Input() public appSyncScroll!: string;
  private serviceIndex: number = -1;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly syncScrollService: SyncScrollService,
  ) {}

  ngOnInit() {
    this.serviceIndex = this.syncScrollService.add(
      this.appSyncScroll,
      this.elementRef,
    );
  }

  ngOnDestroy() {
    this.syncScrollService.remove(this.appSyncScroll, this.serviceIndex);
  }

  @HostListener("scroll") protected onScroll() {
    this.syncScrollService.sync(this.appSyncScroll, this.serviceIndex);
  }
}
